// Hides the app's floating Feedback pill while a page is on screen (Lane 1387). Ryan,
// 2026-10-05: no Feedback button on the sourcing event page or an open Meeting Prep deck
// for now: not in the header, not floating, not in the chat header. Other pages keep the
// floating pill. The page sets a class on the body; workspaceChat.css hides `.fb-float`
// while it is there.
import { useEffect } from 'react';

export const NO_FEEDBACK_BODY_CLASS = 'wchat-no-feedback';

export default function useHideFeedback() {
  useEffect(() => {
    document.body.classList.add(NO_FEEDBACK_BODY_CLASS);
    return () => document.body.classList.remove(NO_FEEDBACK_BODY_CLASS);
  }, []);
}
